module.exports = __webpack_public_path__ + "img/中国荔枝产业大会.f34d6524.png";